import { render, staticRenderFns } from "./Tabbar.vue?vue&type=template&id=dab81fb8&"
import script from "./Tabbar.vue?vue&type=script&lang=js&"
export * from "./Tabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports